import Immutable from 'immutable';
import Conversation from 'models/conversation';

export default {
  fromImmutable(immutableMap, conversationItems) {
    return Conversation.fromJs(immutableMap.toJS(), conversationItems);
  },

  toImmutable(entity) {
    return Immutable.fromJS(entity && entity.toJs());
  },
};



// WEBPACK FOOTER //
// ./src/scripts/adapters/immutable_converters/conversation_converter.js